import moment from 'moment-timezone';
import React from 'react';

import { EventStatus } from '../enums';
import { EventsFilter } from '../interfaces';
import { useTimezone } from '../hooks';

export function FilterDescription(props: { filter: EventsFilter }) {
  let desc = '';
  const { filter } = props;
  const { selectedFilters, dateFrom, dateTo } = filter;
  const timezone = useTimezone();

  switch (filter.status) {
    case 'null':
      desc += 'Unreviewed ';
      break;

    case '!null':
      desc += 'Reviewed ';
      break;

    case EventStatus.approved:
      desc += 'Approved ';
      break;

    case EventStatus.rejected:
      desc += 'Rejected ';
      break;

    default:
      desc += 'All ';
  }

  if (selectedFilters.length > 1) {
    let violations = '';
    violations += selectedFilters.slice(0, -1).join(', ').toLowerCase();
    violations += ' and ';
    violations += selectedFilters.slice(-1).join().toLowerCase();
    violations += ' ';

    violations = violations.replaceAll('_', ' ');
    desc += violations;
  } else if (selectedFilters.length === 1) {
    desc += `${selectedFilters.join().toLowerCase().replace(/_/gi, ' ')} `;
  }

  if (filter.flag !== undefined) {
    desc += 'flagged ';
  }

  desc += 'violations ';

  if (filter.license_plates?.length === 1) {
    desc += `with licence plate ${filter.license_plates.join('').toUpperCase()} `;
  } else if (filter.license_plates?.length > 5) {
    desc += `with any of ${filter.license_plates.length} licence plates `;
  } else if (filter.license_plates?.length > 1) {
    desc += `with any of licence plates ${filter.license_plates.join(', ').toUpperCase()} `;
  }

  desc += `between ${moment(dateFrom).tz(timezone).format('MMM D, hh:mm a')} `;
  desc += `and ${moment(dateTo).tz(timezone).format('MMM Do, hh:mm a')}`;

  return <>{desc}</>;
}
